import React, { useEffect, useRef } from "react";
import dayjs from "dayjs";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { ConfigProvider, Dropdown, Menu } from "antd";

const { SubMenu } = Menu;

const options = {
  title: {
    text: "",
    margin: 50,
    style: { fontSize: "2rem", fontWeight: "bold" },
  },
  chart: {
    style: {
      fontFamily: `Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI",
    "Helvetica Neue", Arial, "Noto Sans", sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`,
    },
  },
  exporting: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  colors: ["#2F5EC4", "#45a5f5"],
  plotOptions: {
    line: {
      lineWidth: 2,
      states: {
        hover: {
          lineWidth: 3,
        },
      },
      marker: {
        enabled: false,
      },
    },
  },
  yAxis: {
    lineWidth: 1,
    title: {
      enabled: false,
    },
  },
  xAxis: {
    type: "datetime",
    labels: {
      style: { fontWeight: "bold" },
    },
    lineWidth: 1,
  },
  tooltip: {
    shared: true,
  },
  series: [
    {
      type: "line",
      name: "TB",
      data: [],
    },
    {
      type: "line",
      name: "TR",
      data: [],
    },
  ],
};

function getData() {
  let data = [...new Array(30)].map((i, index) => [
    dayjs(new Date())
      .subtract(index + 1, "day")
      .unix() * 1000,
    Math.floor(Math.random() * 4000),
  ]);

  return data.sort((a, b) => {
    if (a[0] < b[0]) {
      return -1;
    }
    if (a[0] > b[0]) {
      return 1;
    }
    // a must be equal to b
    return 0;
  });
}

const menu = (changeChartType) => (
  <Menu className="w-32">
    <SubMenu title="Chart type" className="w-32" key="chart-type">
      <Menu.Item key="line" onClick={() => changeChartType("line")}>
        Line
      </Menu.Item>
      <Menu.Item key="spline" onClick={() => changeChartType("spline")}>
        Spline
      </Menu.Item>
      <Menu.Item key="column" onClick={() => changeChartType("column")}>
        Bar
      </Menu.Item>
    </SubMenu>
  </Menu>
);

function Result() {
  const chartRef = useRef(null);

  useEffect(() => {
    if (chartRef && chartRef.current) {
      chartRef.current.chart.series[0].update({
        data: getData(),
      });
      chartRef.current.chart.series[1].update({
        data: getData(),
      });
    }
  }, []);

  function changeChartType(v) {
    if (chartRef && chartRef.current) {
      chartRef.current.chart.series[0].update({
        type: v,
      });
      chartRef.current.chart.series[1].update({
        type: v,
      });
    }
  }

  return (
    <div className="flex flex-col h-full w-full">
      <div className="flex justify-between items-center">
        <div className="flex-shrink-0 flex items-center">
          <span className="font-light text-lg text-gray-700 tracking-wide">
            Plano Analytics
          </span>
        </div>
      </div>

      <div
        className={`flex flex-col mt-1 bg-white border border-gray-200 rounded p-5 pt-7`}
      >
        <div className="flex justify-between items-center mb-12 px-2">
          <h5 className="text-gray-750 mb-0">Traffic</h5>

          <ConfigProvider direction="rtl">
            <Dropdown
              overlay={menu(changeChartType)}
              trigger={["click"]}
              placeholder="bottomRight"
              className="cursor-pointer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4 text-gray-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
                />
              </svg>
            </Dropdown>
          </ConfigProvider>
        </div>

        <HighchartsReact
          ref={chartRef}
          highcharts={Highcharts}
          options={options}
        />
      </div>
    </div>
  );
}

export default Result;
